export const DOCUMENT = "Document";
export const CONFIRMATION = "CONFIRMATION";
export const DELETETOPIC = "DeleteTopic";
export const EDITPROFILEIMG = "EditProfileImg";
export const PARTICIPANTSUBMIT = "ParticipantSubmit";
export const PARTICIPANTREGISTER = "ParticipantRegister";
export const FEEDBACK = "Feedback";
export const GUIDE = "ParticipantGuide";
export const EVENT_CHANGE = "EventChange";
export const EDITSKILLS = "EditSkills";
export const UPLOAD_CV = "UPLOAD_CV"
export const REJECT_REASON = "RejectReason";
export const DECLARE_WINNERS = "DeclareWinners";
